import { createBrowserRouter } from "react-router-dom";
import {adminRoutes} from "./admin/AdminRoutes";
import {userRoutes} from "./user/UserRoutes";
import { siteRouter } from "./site/site.routes";
const router = createBrowserRouter([
  ...siteRouter,
...userRoutes,
...adminRoutes,
]);
export default router;
